import {Injectable} from "@angular/core";
import {PreloaderService} from "./preloader.service";
import {Response} from "@angular/http";

@Injectable()
export class ErrorService {
  constructor(private preloaderService: PreloaderService) {
  }


  handleError(error: any):any {
    this.preloaderService.hide();

    if (error instanceof Response) {
      let r = error as Response;
      let message = `${r.url} ${r.status} ${r.statusText}\n${r.text()}`;
      throw new Error(message);
    } else { // looks like an instance of 'Error'
      throw error;
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/error.service.ts